<template>
  <a :id="id" :title="this.$i18n.translate(title)" @click="click">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    click () {
      !this.disabled && this.$emit('click')
    }
  }
}
</script>
